import { ThemeDefinition } from 'vuetify';

export const vehiclesAndTransport: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#3C92AA',
    'on-subject-original': '#FFFFFF',
    subject: '#347E93',
    'on-subject': '#FFFFFF',
    primary: '#265E6E',
    'on-primary': '#FFFFFF',
    'primary-container': '#C6E3EB',
    'on-primary-container': '#071D36',
    secondary: '#485B61',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D3DCDE',
    'on-secondary-container': '#1A2123',
    surface: '#F7FBFC',
    'on-surface': '#1D1F20',
    'on-surface-medium': '#494F50',
    'on-surface-low': '#949C9E',
    outline: '#798386',
    'outline-variant': '#C9CDCF',
    'inverse-surface': '#243C42',
    'inverse-on-surface': '#FFFFFF',
    'inverse-primary': '#B4DAE4',
    'surface-dim': '#C2E2EB',
    'surface-bright': '#FBFDFE',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F0F8FA',
    'surface-container': '#E8F4F7',
    'surface-container-high': '#D9EDF2',
    'surface-container-highest': '#D1E9F0',
  },
};

export const vehiclesAndTransportDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#3C92AA',
    'on-subject-original': '#F7FBFC',
    subject: '#7FC0D2',
    'on-subject': '#10272D',
    primary: '#B0D8E3',
    'on-primary': '#10272D',
    'primary-container': '#245766',
    'on-primary-container': '#ECF6F8',
    secondary: '#C7D3D6',
    'on-secondary': '#1A2123',
    'secondary-container': '#415358',
    'on-secondary-container': '#F0F3F4',
    surface: '#101719',
    'on-surface': '#F2F3F3',
    'on-surface-medium': '#C9CDCF',
    'on-surface-low': '#798386',
    outline: '#949C9E',
    'outline-variant': '#61696B',
    'inverse-surface': '#DEEAED',
    'inverse-on-surface': '#152428',
    'inverse-primary': '#1B414B',
    'surface-dim': '#0E1415',
    'surface-bright': '#2F4146',
    'surface-container-lowest': '#0C1112',
    'surface-container-low': '#141C1F',
    'surface-container': '#1B2528',
    'surface-container-high': '#233034',
    'surface-container-highest': '#2D3E43',
  },
};
